<template lang="html">
  <div class="right permanent_side col-sm-3 col-xs-12">
    <div class="sticky-wrap">

    <div class="text">חפש והוסף מוצרים להזמנה הקבועה</div>
    <div class="perma_search head_search">
      <div class="head_search_input">
        <input type="text" id="" placeholder="חיפוש"  :minlength="2" v-model="search" />
      </div>
      <div class="head_search_submit" v-if="search==''">
        <input type="submit" value="" /><SEARCH />
      </div>
      <div class="head_search_close_search_perm" v-if="search!=''">
        <a href="javascript:void(0);" @click.prevent="closeSearch();">
          <CLOSE/>
        </a>
      </div>
    </div>
    <div class="perma_results">
      <div class="perma_results_item clearfix" v-for="product in results" :key="product.id">
        <div class="right cart_img"><img v-bind:src="product.image" /></div>
        <div class="right cart_title_wrap">
          <div class="cart_title" v-html="product.name"></div>
          <div class="pr_title_note" v-if="!product.hide_weight">{{ product.weight }} {{product.weight_type}}</div>
          <div class="pr_price" v-bind:class="{ price_sale: product.onsale }">
            {{ product.price }} <span class="currency">{{ currency }}</span>
          </div>
          <div class="pr_price pr_price_old" v-if="product.oldprice">
            {{ product.oldprice }} <span class="currency">{{ currency }}</span>
          </div>
        </div>
        <div class="add_perma ease" @click="addToPermanent(product)">
          <a href="javascript:void(0);">
            <PLUS v-if="!isProductInPerm(product.id)"/>
            <VOK v-else/>
          </a>
        </div>
      </div>
      <div class="perma_results_item" v-if="results && results.length == 0 && !loadingResults && search.length > 2">
        מוזר, אבל אין לנו תוצאות ל״{{search}}״
<br>
        כנראה שאין לנו במלאי, אבל שווה לוודא שהקלדת נכון
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import SEARCH from "../../../assets/img/search.svg";
  import PLUS from "../../../assets/img/plus.svg";
  import CLOSE from "../../../assets/img/close.svg";
  import VOK from "../../../assets/img/ok.svg";
  import { mapActions } from "vuex";
  export default {
    data() {
      return {
        currency: wpData.currencySumbol,
        search: "",
        products : [],
        loadingResults: false,
      };
    },
    methods: {
      ...mapActions(["addToPermanent"]),
      isProductInPerm(productID) {
        if (this.permanentproducts){

          let product = this.permanentproducts.find(p => p.id == productID);
          if (product) {
            return true;
          }
        }
        return false;
      },
      closeSearch() {
        this.search = "";
      },
      searchProducts(s) {

        this.loadingResults = true;
        this.$ajax({
          method: "POST",
          url: homeUrl + "ajax.php",
          params: {
            search: s
          }
        }).then(res => {
          let foundProducts = res.data;
          if (typeof foundProducts != 'undefined' && foundProducts.length > 0) {
            
            foundProducts.sort(function(a, b) {
              if (
                a.categories.includes(16) ||
              a.categories.includes(105) ||
              a.categories.includes(22)
            ) {
              return -1;
            }
            if (
              b.categories.includes(16) ||
              b.categories.includes(105) ||
              b.categories.includes(22)
            ) {
              return 1;
            }
            return 0;
          });
          }
          this.loadingResults = false;
          this.products = foundProducts;
         // resolve(foundProducts);

      });
    }
    },
    mounted() {
      let $footer_h = $('.footer').outerHeight() + 200;
   //   console.log($footer_h);
      $('.sticky-wrap').sticky({topSpacing: 150 , bottomSpacing: $footer_h });
    },
    updated() {
      // if (this.search) {
      //    console.log(this.search);
         
      //   return this.$emit("searching", true);
      // }
    },
    watch: {
      search: function(value){
        if (value.length > 2){

        this.searchProducts(value);
        }

      }
    },
    computed: {
      results() {
        if (!this.search || this.search == "") {
          return false;
        }
        // var productsFound = this.products.filter(product => {
        //   return product.name.toLowerCase().includes(this.search.toLowerCase());
        // });
        return this.products;
      },
      permanentproducts() {
        if (this.$store.state.permanentproducts && this.$store.state.permanentproducts.length > 0) {
          this.showTips = false;
          return this.$store.state.permanentproducts;
        }
        this.showTips = true;
        return false;
      }

    },
    components: {
      SEARCH,
      PLUS,
      CLOSE,
      VOK
    }
  };
</script>
